import access from './access.json';
import app from './app.json';
import account_settings from './account-settings.json';
import app_insights from './app-insights.json';
import calendar from './calendar.json';
import cleaning_task from './cleaning-task.json';
import coke_freestyle from './coke-freestyle.json';
import delivery_monitor from './delivery-monitor.json';
import flowchart from './flow-chart.json';
import ops_plan from './ops-plan.json';
import position_guide from './position-guide.json';
import positioning_plan from './positioning-plan.json';
import sales_tracker from './sales-tracker.json';
import sos from './speed-of-service.json';
import store_core from './store-core.json';
import store_documents from './store-documents.json';
import store_equipment from './store-equipment.json';
import store_inspections from './store-inspections.json';
import store_management from './store-management.json';
import store_settings from './store-settings.json';
import widgets from './widgets.json';
export default {
  access,
  app,
  account_settings,
  app_insights,
  calendar,
  cleaning_task,
  coke_freestyle,
  delivery_monitor,
  flowchart,
  ops_plan,
  position_guide,
  positioning_plan,
  sales_tracker,
  sos,
  store_core,
  store_documents,
  store_equipment,
  store_inspections,
  store_management,
  store_settings,
  widgets,
};
